import {featureFlags} from '@dms/feature-flags';

import {isTrailerOrSemitrailer} from '../../kit/utils/isTrailerOrSemitrailer';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function VehicleConfigurationSubSection() {
  return (
    <VFKit.SubSection data-testid="vehicle-configuration">
      <VFKit.ShowWhen
        name="type"
        condition={(type) => isTrailerOrSemitrailer(type?.at(0) ?? 'VEHICLETYPE_PASSENGER_CAR')}
      >
        <VFKit.AxleCountChips />
      </VFKit.ShowWhen>

      <VFKit.ShowWhen
        name="type"
        condition={(type) => !isTrailerOrSemitrailer(type?.at(0) ?? 'VEHICLETYPE_PASSENGER_CAR')}
      >
        <VFKit.Group data-testid="doors-seats" columns={[1, 2, 2]}>
          <VFKit.DoorTypesChips />
          <VFKit.SeatCountChips />
        </VFKit.Group>
      </VFKit.ShowWhen>

      <VFKit.ShowWhen
        whenFeatureEnabled={featureFlags.ADVERTISEMENT_PER_PLATFORM_ATTRIBUTES}
        name="type"
        condition={(type) =>
          (type?.at(0) ?? 'VEHICLETYPE_PASSENGER_CAR') === 'VEHICLETYPE_PASSENGER_CAR'
        }
      >
        <VFKit.TruckHomologationCheckbox />
      </VFKit.ShowWhen>
    </VFKit.SubSection>
  );
}
